var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"centered":"","title":"Delete Custom Panel"},on:{"ok":_vm.deletePanel}},[_vm._v(" Are you sure you want to delete custom panel \""+_vm._s(_vm.name)+"\"? You cannot undo this action. ")])}
var staticRenderFns = []

export { render, staticRenderFns }